/**
 * 차트 인터랙션 feature 게이팅 (ERD-234).
 *
 * native가 webview 차트 URL hash에 repeated-key로 붙이는 `enabled_features`로 게이팅한다
 * (앱 버전 아님). 웹은 항상 활성, 웹뷰는 키가 있을 때만 활성.
 */

/** ERD-234 정의 키. */
export const ENABLED_FEATURE = {
  /** 생성/수정/삭제/청산 드래그 인터랙션. */
  DraggableTpSl: 'draggable_tpsl',
  /** Limit TP/SL 옵션. */
  LimitTpSl: 'limit_tpsl',
} as const;

/** webview 차트 URL hash의 repeated-key `enabled_features`를 배열로 파싱한다. */
export function parseEnabledFeatures(hashString: string): string[] {
  return new URLSearchParams(hashString).getAll('enabled_features');
}

/**
 * draggable TP/SL 인터랙션 활성 여부.
 * - 웹: 항상 활성.
 * - 웹뷰: URL `enabled_features`에 `draggable_tpsl`이 있을 때만.
 */
export function isDraggableTpslEnabled(opts: { isWebview: boolean; enabledFeatures: string[] }): boolean {
  if (!opts.isWebview) return true;
  return opts.enabledFeatures.includes(ENABLED_FEATURE.DraggableTpSl);
}
